import request from '@/utils/request'

// 根据明细ID查询阶梯报价明细
export function getInfoByLineId(lineId) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyStepPrice/getInfoByLineId/' + lineId,
    method: 'get'
  })
}
